import React from "react";
import clsx from "clsx";

export function Card({ children, className, ...rest }) {
  return (
    <div
      className={clsx(
        "bg-white/80 backdrop-blur-sm rounded-3xl shadow-soft border border-white/50 transition-all hover:shadow-lg",
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
}

export function CardHeader({ children, className }) {
  return (
    <div
      className={clsx(
        "px-4 py-3 border-b border-gray-200 font-semibold text-gray-800 text-lg",
        className
      )}
    >
      {children}
    </div>
  );
}

export function CardContent({ children, className }) {
  return (
    <div className={clsx("px-4 py-3 text-gray-700", className)}>
      {children}
    </div>
  );
}

export function CardFooter({ children, className }) {
  return (
    <div
      className={clsx(
        "px-4 py-3 border-t border-gray-200 text-sm text-gray-600",
        className
      )}
    >
      {children}
    </div>
  );
}
